import { render, staticRenderFns } from "./competitionAiRender.vue?vue&type=template&id=1020b916&scoped=true&"
import script from "./competitionAiRender.vue?vue&type=script&lang=js&"
export * from "./competitionAiRender.vue?vue&type=script&lang=js&"
import style0 from "./competitionAiRender.vue?vue&type=style&index=0&id=1020b916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1020b916",
  null
  
)

export default component.exports